module.exports = __webpack_public_path__ + "static/media/90a.c67169a4.svg";